module.exports = __webpack_public_path__ + "static/media/more.adbd8d6d.svg";